module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select form-status"
  }, [_c('select', {
    ref: "slEstados",
    staticClass: "select2 item-status",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data-select2-container": "item-status-cont"
    },
    domProps: {
      "value": _vm.estadoorigen
    }
  }, [_c('option', {
    attrs: {
      "data-class": _vm.getClassInicial()
    },
    domProps: {
      "value": _vm.estadoorigen
    }
  }, [_vm._v(_vm._s(_vm.getTextInicial()))]), _vm._v(" "), _vm._l((_vm.estadosDisponibles), function(estado) {
    return _c('option', {
      attrs: {
        "data-class": estado.class
      },
      domProps: {
        "value": estado.id
      }
    }, [_vm._v(_vm._s(estado.text))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f536d7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Restaurante/ComboEstados.vue
// module id = 1106
// module chunks = 5